import VxeOptionComponent from '../select/src/option';
import { dynamicApp } from '../dynamics';
export var VxeOption = Object.assign(VxeOptionComponent, {
    install: function (app) {
        app.component(VxeOptionComponent.name, VxeOptionComponent);
    }
});
export var Option = VxeOption;
dynamicApp.component(VxeOptionComponent.name, VxeOptionComponent);
export default VxeOption;
